import React from "react";
import Content from "../../../content/Content";
import Store from "../../../content/Store";
import Information from "../Information";
import ErrorContentLinks from "./sharedErrorContent/ErrorContentLinks";

export const RestrictedUser = () => {
  return (
    <Information headerText={Store.ErrorPages.RestrictedUser.HeaderText}>
      <Content name={Store.ErrorPages.RestrictedUser.Message} />
      <ErrorContentLinks />
    </Information>
  );
};
